<template>
  <div>
    <data-card
      class="data-card mt-4 mb-0 d-mr-4 d-ml-4"
      type="orderBuy"
      :loading="loading"
    >
      <b-row no-gutters>
        <b-col>
          <h3 class="">مشخصات تیکت</h3>
        </b-col>
        <b-col v-if="ticket.status != 'resolved'" class="text-left">
          <b-button @click="closeTicket()" size="sm" variant="danger">
            بستن تیکت
          </b-button>
        </b-col>
      </b-row>
      <hr class="seperator mt-2" />
      <b-row no-gutters>
        <b-col cols="12" md="6">
          <b-row no-gutters>
            <b-col cols="6" class="mb-3 mt-3"> <b>موضوع:</b></b-col>
            <b-col cols="6" class="text-left mb-3 mt-3 dir-ltr d-pl-2">
              {{ ticket.subject }}
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6">
          <b-row no-gutters>
            <b-col cols="6" class="mb-3 mt-3 d-pr-2"> <b>تاریخ:</b></b-col>
            <b-col cols="6" class="text-left mb-3 mt-3 dir-ltr">
              {{
                new Date(ticket.created).toLocaleString("fa-ir", {
                  timeZone: "Asia/Tehran",
                })
              }}
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" md="6">
          <b-row no-gutters v-if="ticket.department.title">
            <b-col cols="6" class="mb-3 mt-3"> <b>دپارتمان:</b></b-col>
            <b-col cols="6" class="text-left mb-3 mt-3 d-pl-2 dir-ltr">
              {{ ticket.department.title }}
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6">
          <b-row no-gutters>
            <b-col cols="6" class="mb-3 mt-3 d-pr-2"> <b>اولویت:</b></b-col>
            <b-col cols="6" class="text-left mb-3 mt-3 dir-ltr">
              {{ getPrioriyName(ticket.priority) }}
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" md="6">
          <b-row no-gutters v-if="ticket.department.title">
            <b-col cols="6" class="mb-3 mt-3"> <b>کاربر:</b></b-col>
            <b-col cols="6" class="text-left mb-3 mt-3 dir-ltr d-pr-2">
              <b-link :to="'/user-profile/' + ticket.owner">
                نمایش پروفایل کاربر
              </b-link>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="12" class="mb-3"><b>متن:</b></b-col>
        <b-col cols="12" class="text-right mb-3 dir-ltr">
          {{ ticket.message }}
        </b-col>

        <b-col v-if="ticket.attachments[0]" cols="12" class="mb-3">
          <b>فایل ضمیمه:</b>
        </b-col>
        <b-col
          v-if="ticket.attachments[0]"
          cols="12"
          class="text-right mb-3 dir-ltr"
        >
          <b-img
            @click="showAttachment(ticket.attachments[0])"
            class="ticket-attachment"
            :src="baseURL + ticket.attachments[0]"
          ></b-img>
        </b-col>
      </b-row>
      <b-row no-gutters> </b-row>

      <hr class="seperator" />

      <b-row no-gutters>
        <b-col md="12">
          <h3 class="class-header mt-3">پاسخ ها</h3>

          <div v-for="(message, index) in ticket.replies" :key="index">
            <b-media
              :class="
                ticket.owner == message.owner
                  ? 'message-item text-left'
                  : 'message-reply text-right'
              "
              :right-align="ticket.owner == message.owner ? true : false"
            >
              <template #aside>
                <b-avatar
                  width="64"
                  variant="info"
                  :src="baseURL + message.user_pic"
                ></b-avatar>
              </template>

              <p>
                {{ message.message }}
              </p>

              <div v-if="message.attachments[0]">
                <hr class="mt-3 mb-3" />
                <div cols="12" class="mb-2 mr-0"><b>فایل ضمیمه:</b></div>

                <b-img
                  @click="showAttachment(message.attachments[0])"
                  class="ticket-attachment"
                  :src="baseURL + message.attachments[0]"
                ></b-img>
              </div>
            </b-media>
          </div>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col>
          <h3 class="class-header mb-3 mt-2">ارسال پاسخ</h3>
          <validation-observer
            v-slot="{ invalid, handleSubmit }"
            ref="formValidator"
          >
            <b-form role="form" @submit.prevent="handleSubmit().then(onSubmit)">
              <div class="form">
                <b-row no-gutters>
                  <b-col sm="12">
                    <b-form-textarea
                      id="textarea"
                      v-model="message"
                      placeholder="متن پاسخ..."
                      rows="3"
                      max-rows="6"
                    >
                    </b-form-textarea>
                  </b-col>
                </b-row>

                <b-row no-gutters class="mb-4 mt-4">
                  <b-col>
                    <b-form-file
                      v-model="attached"
                      ref="file"
                      type="file"
                      id="file"
                      @input="changeFile()"
                      placeholder="یک فایل انتخاب کنید"
                      drop-placeholder="فایل را در اینجا بیاندازید"
                    ></b-form-file>
                  </b-col>
                </b-row>

                <hr class="form-seperator" />

                <b-row no-gutters class="text-right ticket-button-container">
                  <b-col>
                    <b-overlay
                      :show="busy"
                      rounded
                      opacity="0.6"
                      spinner-small
                      spinner-variant="primary"
                      class="mt-3"
                    >
                      <button
                        class="btn submit-button"
                        type="submit"
                        :disabled="invalid || message.length < 2"
                      >
                        <b-icon
                          v-if="busy"
                          icon="circle-fill"
                          animation="throb"
                          font-scale="1"
                        ></b-icon>
                        ارسال پاسخ
                      </button>
                    </b-overlay>
                  </b-col>
                </b-row>
              </div>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </data-card>
  </div>
</template>
<script>
import DataCard from "@/components/Cards/DataCard";
import axios from "axios";

export default {
  name: "ticket-profile",
  components: {
    DataCard,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_TICKETSERVICE_URL,
      loading: true,
      busy: false,
      ticket: {},
      message: "",
      attached: null,
    };
  },
  mounted() {
    this.getTicket();
  },
  methods: {
    showAttachment(link) {
      this.$swal({
        text: "فایل ضمیمه",
        imageUrl: this.baseURL + link,
        showConfirmButton: false,
      });
    },

    closeTicket() {
      this.busy = true;
      let data = {
        uid: this.$route.params.uid,
        status: "resolved",
      };
      this.$store
        .dispatch("closeTicket", data)
        .then((res) => {
          console.log(res);

          this.message = "";
          this.attached = "";

          this.$swal({
            position: "center",
            icon: "success",
            title: "تیکت بسته شد",
            showConfirmButton: false,
            timer: 1500,
          });

          this.$router.push("/support");

          this.modalShow = false;
          this.busy = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = true;
          this.busy = false;
          this.$swal({
            position: "center",
            icon: "error",
            title: "خطا در ثبت اطلاعات",
            showConfirmButton: false,
            timer: 1500,
          });

          let errorResponse = this.errorHandler(err);
        });
    },

    changeFile() {
      // console.log(this.$refs.file.files[0]);
    },

    onSubmit() {
      this.busy = true;
      let data = {
        uid: this.$route.params.uid,
        message: this.message,
        attached: this.attached,
      };
      this.$store
        .dispatch("replyTicket", data)
        .then((res) => {
          console.log(res);
          this.getTicket();
          this.message = "";
          this.attached = "";

          this.$swal({
            position: "center",
            icon: "success",
            title: "پاسخ با موفقیت ثبت شد",
            showConfirmButton: false,
            timer: 1500,
          });

          this.modalShow = false;
          this.busy = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = true;
          this.busy = false;
          this.$swal({
            position: "center",
            icon: "error",
            title: "خطا در ثبت اطلاعات",
            showConfirmButton: false,
            timer: 1500,
          });

          let errorResponse = this.errorHandler(err);
        });
    },

    getTicket() {
      // this.loading = true;

      axios({
        method: "get",
        url:
          process.env.VUE_APP_TICKETSERVICE_URL +
          "/api/tickets/uid/" +
          this.$route.params.uid,
        //baseURL: process.env.VUE_APP_BASE_URL,
        crossDomain: true,
        headers: {
          //'Access-Control-Allow-Origin': '*',
          Authorization: "Bearer " + this.$store.getters.token,
        },
      })
        .then((response) => {
          this.ticket = response.data;

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let errorResponse = this.errorHandler(err);
        });
    },

    getPrioriyName(id) {
      if (id === 1) {
        return "کم";
      }
      if (id === 2) {
        return "متوسط";
      }
      if (id === 3) {
        return "زیاد";
      }
    },
  },
};
</script>

<style lang="scss">
.ticket-attachment {
  cursor: pointer;
  width: 30%;

  @media (max-width: 991px) {
    width: 100%;
  }
}

.ticket-button-container {
  .b-overlay {
    width: 173px;
  }

  @media (max-width: 991px) {
    .b-overlay {
      width: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
.submit-button {
  padding: 8px 40px;
  height: 36px;
  // margin-bottom: 24px;
  margin: 0;
  border-radius: 4px;
  background-color: #2a6ae3;
  color: #fff;
}

@media (max-width: 991px) {
  .submit-button {
    width: 100%;
  }
}

.message-item {
  background: #ededed;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.message-reply {
  background: #c6e2ce;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.media-aside {
  margin-right: 0;
}

.media-aside-right {
  margin-left: 0;
}

.media-body {
  padding-top: 8px;
  padding-right: 16px;
  padding-left: 16px;

  p {
    margin-bottom: 0;
  }
}

.custom-file {
  text-align: center;
}
</style>
